/* Reversible disclosure motion. No cart, variant or engraving-price state lives here. */
(function () {
  'use strict';
  if (window.SPQRAccordionMotion) return;
  var media = window.matchMedia('(prefers-reduced-motion: reduce)');
  var states = new WeakMap();
  var active = new Set();
  function reduced() { return media.matches; }

  function makeWrapper(parent, nodes, padded) {
    var wrapper = document.createElement('div');
    wrapper.className = 'spqr-disclosure-motion';
    var inner = document.createElement('div');
    inner.className = 'spqr-disclosure-motion__inner';
    var content = inner;
    if (padded) {
      content = document.createElement('div');
      content.className = 'spqr-panel-motion__padding';
      inner.appendChild(content);
    }
    nodes.forEach(function (node) { content.appendChild(node); });
    wrapper.appendChild(inner);
    parent.appendChild(wrapper);
    return wrapper;
  }

  function finish(state) {
    clearTimeout(state.timer);
    state.wrapper.classList.toggle('is-settled', state.open);
    if (!state.open) {
      if (state.summary) { state.domOpen = false; state.parent.open = false; }
      else state.parent.hidden = true;
    }
    active.delete(state);
  }

  function reveal(state, open) {
    clearTimeout(state.timer);
    var duration = window.SPQRMotion ? window.SPQRMotion.duration(open ? 'open' : 'close') : (open ? 360 : 260);
    state.wrapper.style.setProperty('--spqr-disclosure-duration', duration + 'ms');
    state.open = open;
    state.wrapper.classList.remove('is-settled');
    if (state.summary) state.summary.setAttribute('aria-expanded', String(open));
    // Prevent keyboard navigation into closing content immediately, before its visual exit ends.
    state.wrapper.inert = !open;
    if (open) {
      if (state.summary) { state.domOpen = true; state.parent.open = true; }
      else state.parent.hidden = false;
      // Establish the collapsed start only for an actually hidden panel. Reversals keep their current frame.
      if (!state.wrapper.classList.contains('is-expanded')) void state.wrapper.offsetHeight;
    } else if (state.wrapper.contains(document.activeElement)) {
      if (state.summary) state.summary.focus({ preventScroll: true });
      else state.parent.parentElement.querySelector('[data-engraving-toggle]')?.focus({ preventScroll: true });
    }
    state.wrapper.classList.toggle('is-expanded', open);
    if (reduced()) { finish(state); return; }
    active.add(state);
    state.timer = setTimeout(function () { finish(state); }, duration + 20);
  }

  function details(parent) {
    if (states.has(parent)) return;
    var summary = Array.from(parent.children).find(function (node) { return node.tagName === 'SUMMARY'; });
    if (!summary) return;
    var nodes = Array.from(parent.childNodes).filter(function (node) { return node !== summary; });
    var wrapper = makeWrapper(parent, nodes, false);
    var state = { parent: parent, summary: summary, wrapper: wrapper, open: parent.open, domOpen: parent.open, timer: null };
    states.set(parent, state);
    wrapper.classList.toggle('is-expanded', state.open);
    wrapper.classList.toggle('is-settled', state.open);
    wrapper.inert = !state.open;
    summary.setAttribute('aria-expanded', String(state.open));
    summary.addEventListener('click', function (event) {
      // Links or other controls deliberately nested in a summary retain their native actions.
      if (event.target.closest('a,button,input,select,textarea')) return;
      event.preventDefault();
      reveal(state, !state.open);
    });
    parent.addEventListener('toggle', function () {
      // Honour external changes and native exclusive details groups without creating a second toggle.
      if (parent.open !== state.domOpen) { state.domOpen = parent.open; reveal(state, parent.open); }
    });
  }

  function setPanel(parent, open) {
    var state = states.get(parent);
    if (!state) {
      var padding = getComputedStyle(parent).padding;
      parent.style.setProperty('--spqr-panel-padding', padding || '12px');
      parent.classList.add('spqr-panel-motion');
      var wrapper = makeWrapper(parent, Array.from(parent.childNodes), true);
      state = { parent: parent, wrapper: wrapper, open: !parent.hidden, timer: null };
      states.set(parent, state);
      wrapper.classList.toggle('is-expanded', state.open);
    }
    reveal(state, open);
  }

  function boot(scope) {
    // Navigation disclosure menus have independent hover/focus logic; enhance content accordions only.
    (scope || document).querySelectorAll('#MainContent details, .spqr-selection-guide details, .spqr-product-guidance details').forEach(details);
  }
  window.SPQRAccordionMotion = { setPanel: setPanel };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
  media.addEventListener('change', function () { if (reduced()) active.forEach(finish); });
})();
